import type { LogicalRange } from "lightweight-charts";

interface VisibleLogicalRangeHandlerProps {
	newVisibleLogicalRange: LogicalRange | null;
	from: number;
	duration: number;
	isLoading: boolean;
	hasData: boolean;
	setFrom: React.Dispatch<React.SetStateAction<number>>;
}

export function visibleLogicalRangeHandler(
	props: VisibleLogicalRangeHandlerProps,
) {
	const {
		newVisibleLogicalRange,
		from,
		duration,
		isLoading,
		hasData,
		setFrom,
	} = props;

	if (
		newVisibleLogicalRange &&
		!Number.isNaN(newVisibleLogicalRange.from) &&
		newVisibleLogicalRange.from < 0
	) {
		if (!isLoading && hasData) {
			setFrom(from - duration);
		}
	}
}
